import { render, staticRenderFns } from "./subProductInfoList.vue?vue&type=template&id=16307651&scoped=true&"
import script from "./subProductInfoList.vue?vue&type=script&lang=js&"
export * from "./subProductInfoList.vue?vue&type=script&lang=js&"
import style0 from "./subProductInfoList.vue?vue&type=style&index=0&id=16307651&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16307651",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16307651')) {
      api.createRecord('16307651', component.options)
    } else {
      api.reload('16307651', component.options)
    }
    module.hot.accept("./subProductInfoList.vue?vue&type=template&id=16307651&scoped=true&", function () {
      api.rerender('16307651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/commodity_management/components/subProductInfoList.vue"
export default component.exports